import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {DispatchPaymentStatus} from "../../constants";

@Component({
  selector: 'exception-dialog',
  templateUrl: 'exception-dialog.html',
  styleUrl: 'exception-dialog.scss',
  imports: [MatDialogModule, MatButton, FormsModule, ReactiveFormsModule],
})
export class ExceptionDialog {
  readonly dialogRef = inject(MatDialogRef<ExceptionDialog>);
  data = inject(MAT_DIALOG_DATA);

  constructor(private fb: FormBuilder) {}

  exceptionForm = this.fb.group({
    exception: ['', Validators.required],
  });

  paidForm = this.fb.group({
    voucher: ['', Validators.required],
  })

  get fe() {
    return this.exceptionForm.controls;
  }

  get fp() {
    return this.paidForm.controls;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  protected readonly DispatchPaymentStatus = DispatchPaymentStatus;
}
